module.exports = __webpack_public_path__ + "img/1486653074.115684cc.jpg";